export interface IPreselectStatistics {
    centerId: number,
    centerAlias: string,
    centerName: string,
    hasExportablePairs: boolean,
    totalMatches: number,
    pendingMatches: number,
    acceptedMatches: number,
    declinedMatches: number,
    reEvalsNeeded: number,
    acceptedPercent: number,
    declinedPercent: number,
    percentReviewed: number,
    averagePercentReviewedThisMonth: number,
    preSelectsPending: number,
}